import { Injector } from '@angular/core';
import { LookupGetService } from '../../../../service/lookup-service/lookup-get.service';
import { CodeName } from '../../../../service/lookup-service/code-name.model';
import { Art57Section } from '../../../Art57Section/Art57Section';
import { DrugIngredientEntity } from '../../../Data/MedicinalProductData/DrugIngredientEntity';
import { Art57Node } from '../../Art57Node/Art57Node';
import { Art57NodeUtils } from '../../Art57Node/Art57NodeUtils';
import { FieldDefinition } from '../../../../../sections/medicinalProduct/message/fieldDefinition';
import { ApprovedSubstanceAutoUploadEntity } from './ApprovedSubstanceAutoUploadEntity';
import { DevelopmentSubstanceAutoUploadEntity } from './DevelopmentSubstanceAutoUploadEntity';
import { DrugIngredientUtil } from '../../../DrugIngredientUtil';
import { BaseNode } from '../../BaseNode';
import { environment } from '../../../../../../environments/environment';

export class TreeNodeDrugIngredientEntity extends Art57Node {
  useHist: boolean = false;
  constructor(injector: Injector, parent: BaseNode) {
    super(
      injector,
      new DrugIngredientEntity(new FieldDefinition(injector)),
      'Drug Ingredient'
    );
    this.parent = parent;
    this.labelNodeName = 'Drug Ingredient';
    this.ioc!.get(Art57Section).generateNumColumValue(this);
    this.refreshLabel();
  }

  override refreshLabel(lazy: boolean = true): void {
    let param1 = '';
    let param2 = '';
    let separator = '';

    if (
      this.data &&
      this.data.model &&
      this.data.model.substancecode &&
      this.data.model.substancecode.value
    ) {
      if (this.data.model.substancecode.name) {
        param1 = this.data.model.substancecode.name;
      } else if (!lazy) {
        this.ioc!.get(LookupGetService)
          .getLookup('substance', this.data.model.substancecode.value + '_1')
          .then((result: CodeName) => {
            if (result && result.name && result.name != '') {
              this.data.model.substancecode.name = result.name;
              this.refreshLabel();
            }
          });
      }
    }

    if (this.data && this.data.model && this.data.model.roleofingredient) {
      param2 = this.ioc!.get(LookupGetService).retrieveValueFromCache(
        'roleofingredient',
        this.data.model.roleofingredient
      );
    }

    if (param1 != '' || param2 != '') {
      if (param1 != '' && param2 != '') {
        separator = ' - ';
      }
      this.label = param1 + separator + param2;
    } else {
      this.label = this.labelTemplate;
    }
  }

  mask(condition: boolean, value: string): string {
    if (condition) {
      return "***";
    } else {
      return value;
    }
  }

  override getListItem(): any[] {
    DrugIngredientUtil.setStrength(this.ioc!, this.data.model);
    let lowDenominatorUnitSearchedValue =
      this.data.model.lowAmountConditionalGroup?.lowamountdenomunit?.value;
    let lowDenominatorUnitLookUpWithValues = '';
    switch (this.data.model.strength) {
      case 1:
        lowDenominatorUnitLookUpWithValues = 'unitofmeasurement';
        break;
      case 2:
        lowDenominatorUnitLookUpWithValues = 'unitofpresentation';
        break;
    }

    let highDenominatorUnitSearchedValue =
      this.data.model.highAmountConditionalGroup?.highamountdenomunit?.value;
    let highDenominatorUnitLookUpWithValues =
      lowDenominatorUnitLookUpWithValues;

    return [
      this.data.model &&
        this.data.model.substancecode &&
        this.data.model.substancecode.value
        ? this.data.model.substancecode.value
        : '-',
      this.data.model &&
        this.data.model.substancecode &&
        this.data.model.substancecode.value
        ? this.data.model.substancecode.name
        : 'Not selected',
      this.data.model && this.data.model.roleofingredient
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'roleofingredient',
          this.data.model.roleofingredient
        )
        : 'Not selected',
      this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
        this.data.model &&
          this.data.model.concentrationtypecode &&
          this.data.model.concentrationtypecode.value
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'amountvaluetype',
            this.data.model.concentrationtypecode.value
          )
          : '')

      ,
            this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.lowAmountConditionalGroup &&
        this.data.model.lowAmountConditionalGroup.lowamountnumervalue
        ? this.data.model.lowAmountConditionalGroup.lowamountnumervalue
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.lowAmountConditionalGroup &&
        this.data.model.lowAmountConditionalGroup.lowamountnumerprefix &&
        this.data.model.lowAmountConditionalGroup.lowamountnumerprefix.value
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'amountprefix',
          this.data.model.lowAmountConditionalGroup.lowamountnumerprefix.value
        )
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.lowAmountConditionalGroup &&
        this.data.model.lowAmountConditionalGroup.lowamountnumerunit &&
        this.data.model.lowAmountConditionalGroup.lowamountnumerunit.value
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'amountnumerunit',
          this.data.model.lowAmountConditionalGroup.lowamountnumerunit.value
        )
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.lowAmountConditionalGroup &&
        this.data.model.lowAmountConditionalGroup.lowamountdenomvalue
        ? this.data.model.lowAmountConditionalGroup.lowamountdenomvalue
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.lowAmountConditionalGroup &&
        this.data.model.lowAmountConditionalGroup.lowamountdenomprefix &&
        this.data.model.lowAmountConditionalGroup.lowamountdenomprefix.value
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'amountprefix',
          this.data.model.lowAmountConditionalGroup.lowamountdenomprefix.value
        )
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      lowDenominatorUnitSearchedValue && lowDenominatorUnitLookUpWithValues
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          lowDenominatorUnitLookUpWithValues,
          lowDenominatorUnitSearchedValue
        )
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.highAmountConditionalGroup &&
        this.data.model.highAmountConditionalGroup.highamountnumervalue
        ? this.data.model.highAmountConditionalGroup.highamountnumervalue
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.highAmountConditionalGroup &&
        this.data.model.highAmountConditionalGroup.highamountnumerprefix &&
        this.data.model.highAmountConditionalGroup.highamountnumerprefix.value
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'amountprefix',
          this.data.model.highAmountConditionalGroup.highamountnumerprefix
            .value
        )
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.highAmountConditionalGroup &&
        this.data.model.highAmountConditionalGroup.highamountnumerunit &&
        this.data.model.highAmountConditionalGroup.highamountnumerunit.value
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'amountnumerunit',
          this.data.model.highAmountConditionalGroup.highamountnumerunit.value
        )
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.highAmountConditionalGroup &&
        this.data.model.highAmountConditionalGroup.highamountdenomvalue
        ? this.data.model.highAmountConditionalGroup.highamountdenomvalue
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      this.data.model.highAmountConditionalGroup &&
        this.data.model.highAmountConditionalGroup.highamountdenomprefix &&
        this.data.model.highAmountConditionalGroup.highamountdenomprefix.value
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'amountprefix',
          this.data.model.highAmountConditionalGroup.highamountdenomprefix
            .value
        )
        : ''),
              this.mask(this.data.model &&
          this.data.model.concentrationtypecode &&
          (this.data.model.concentrationtypecode.value===0),
      highDenominatorUnitSearchedValue && highDenominatorUnitLookUpWithValues
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          highDenominatorUnitLookUpWithValues,
          highDenominatorUnitSearchedValue
        )
        : ''),
    ];
  }

  override setMessage(jsonObject: any) {
    let defaultJson = {
      substancecode: jsonObject.substancecode,
      roleofingredient: jsonObject.roleofingredient,
      ingredientStrengthInformation: jsonObject.ingredientStrengthInformation,
      concentrationtypecode: jsonObject.concentrationtypecode,
      strength: jsonObject.strength,
    };

    super.setMessage(defaultJson);

    let lowAmountConditionalGroupJSON = {
      lowAmountConditionalGroup: {
        lowamountnumervalue: jsonObject.lowamountnumervalue,
        lowamountnumerprefix: jsonObject.lowamountnumerprefix,
        lowamountnumerunit: jsonObject.lowamountnumerunit,
        lowamountdenomvalue: jsonObject.lowamountdenomvalue,
        lowamountdenomprefix: jsonObject.lowamountdenomprefix,
        lowamountdenomunit: jsonObject.lowamountdenomunit,
      },
    };

    if (lowAmountConditionalGroupJSON) {
      Art57NodeUtils.generateFormlyModel(
        this.data.fields,
        lowAmountConditionalGroupJSON,
        this.data.model,
        'lowAmountConditionalGroup'
      );
    }

    let highAmountConditionalGroupJSON = {
      highAmountConditionalGroup: {
        highamountnumervalue: jsonObject.highamountnumervalue,
        highamountnumerprefix: jsonObject.highamountnumerprefix,
        highamountnumerunit: jsonObject.highamountnumerunit,
        highamountdenomvalue: jsonObject.highamountdenomvalue,
        highamountdenomprefix: jsonObject.highamountdenomprefix,
        highamountdenomunit: jsonObject.highamountdenomunit,
      },
    };

    if (highAmountConditionalGroupJSON) {
      Art57NodeUtils.generateFormlyModel(
        this.data.fields,
        highAmountConditionalGroupJSON,
        this.data.model,
        'highAmountConditionalGroup'
      );
    }

    if (jsonObject.substance) {
      switch (jsonObject.substance.type_substance) {
        case 1:
          this.children?.push(
            new DevelopmentSubstanceAutoUploadEntity(
              this.ioc!,
              `Development - ${jsonObject.substancecode.value} - ${jsonObject.substancecode.name}`,
              this,
              jsonObject.substance,
              this.useHist,
              false,
              false
            )
          );
          break;
        case 2:
          this.children?.push(
            new ApprovedSubstanceAutoUploadEntity(
              this.ioc!,
              `Approved - ${jsonObject.substancecode.value} - ${jsonObject.substancecode.name}`,
              this,
              jsonObject.substance,
              this.useHist,
              false,
              false
            )
          );
          break;
      }
    }
  }

  override cloneNode(newParent: BaseNode): BaseNode|undefined {
    let clonedNode: TreeNodeDrugIngredientEntity = new TreeNodeDrugIngredientEntity(this.ioc!, newParent);

    clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

    clonedNode.refreshLabel();
    clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning || environment.userPreferences.alwaysAutoexpandNodes)


    this.children?.forEach((child) => {
      let childToClone = child as BaseNode;
      let clonedChildren = childToClone.cloneNode(clonedNode);
      if (clonedChildren) {
          clonedNode.children?.push(clonedChildren);
          clonedChildren.refreshLabel();
      }
    });

    // property doesn't exist      clonedNode.cloningNode = false;
    return clonedNode;
  }

}
